/* eslint-disable no-restricted-globals */
import { authHeader, history } from "../_helpers";
export const userService = {
  login,
  logout,
  register,
  getAllUsers,
  getAllUsersForImpersonation,
  getUserTopCardInfo,
  editUserDetailsByAdmin,
  getUserProfile,
  getById,
  update,
  delete: _delete,
  resetPassword,
  verifyToken,
  verifyDefaultToken,
  createPassword,
  changePassword,
  updateProfile,
  updatePassword,
  getAllNotifications,
  getAccessControl,
  getAllCardsForUser,
  getAccessControlForUser,
  postAccessControlForUser,
  getAccessControlForUserByToken,
  getUserFilters,
  applyUserFilter,
  getSessionInfo,
  onboardRequest,
  retrieveCustomerDetails,
  applyFilterNofitications,
  registerDemoClient,
  getNotificationCount,
  checkDuplicateUserName,
  updateNotification,
  DuplicateUserNameForDemo,
  fetchAllLoginDetailsForUser,
  logutUserByTokenId,
  // closeAccount,
  verfiyUserSubscription,
  resendUserVerification,
  loginAsUserImpersona,
  createMPin,
  fetchAllLoginDetails,
  userSessionTopCards,
  getAllUserSessionFilters,
  applyUserSessionFilters,
  managedAInotification,
  shareSecurAssetByEmail,
  getAllActiveUsers,
  updateIsNewNotificationId,
  getNotification,
  searchNotification,
  applyNotification,
  fetchNotificationOptions,
  signup,
  checkDomainAvailability,
  generateEmailOTP,
  verifyEmailOTP,
  resendEmailOTP,
};

function shareSecurAssetByEmail(formData) {
  let users = JSON.parse(localStorage.getItem("user"));
  const requestOptions = {
    method: "POST",
    headers: {
      "x-access-token": users.accessToken,
      "content-type": "application/json",
    },
    body: JSON.stringify(formData),
  };
  return fetch(
    `${process.env.REACT_APP_BACKEND_API_URL}/api/v1/shares`,
    requestOptions
  ).then(handleResponse);
}

function getUserFilters() {
  let user = JSON.parse(localStorage.getItem("user"));
  // const id = "notebook";
  const requestOptions = {
    method: "GET",
    headers: {
      "x-access-token": user.accessToken,
    },
  };

  return fetch(
    `${process.env.REACT_APP_BACKEND_API_URL}/api/v1/users/filter/props`,
    requestOptions
  ).then(handleResponse);
}

function getAllNotifications(offset, limit) {
  let user = JSON.parse(localStorage.getItem("user"));
  const requestOptions = {
    method: "GET",
    headers: {
      "x-access-token": user.accessToken,
    },
  };

  return fetch(
    `${process.env.REACT_APP_BACKEND_API_URL}/api/v1/notification/${offset}/${limit}`,
    requestOptions
  ).then(handleResponse);
}

function updateNotification() {
  let user = JSON.parse(localStorage.getItem("user"));
  const requestOptions = {
    method: "PUT",
    headers: {
      "x-access-token": user.accessToken,
    },
  };

  return fetch(
    `${process.env.REACT_APP_BACKEND_API_URL}/api/v1/notification`,
    requestOptions
  ).then(handleResponse);
}
function getNotificationCount() {
  let user = JSON.parse(localStorage.getItem("user"));
  const requestOptions = {
    method: "GET",
    headers: {
      "x-access-token": user.accessToken,
    },
  };
  return fetch(
    `${process.env.REACT_APP_BACKEND_API_URL}/api/v1/notifications/count`,
    requestOptions
  ).then(handleResponse);
}

function updatePassword(oldPassword, newPassword) {
  let user = JSON.parse(localStorage.getItem("user"));
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "x-access-token": user.accessToken,
    },
    body: JSON.stringify({ oldPassword, newPassword }),
  };

  return fetch(
    `${process.env.REACT_APP_BACKEND_API_URL}/api/v1/user/password/reset`,
    requestOptions
  ).then(handleResponse2);
}

function updateProfile(formData) {
  let user = JSON.parse(localStorage.getItem("user"));
  const requestOptions = {
    method: "PUT",
    headers: {
      "x-access-token": user.accessToken,
    },
    body: formData,
  };

  return fetch(
    `${process.env.REACT_APP_BACKEND_API_URL}/api/v1/user/profile`,
    requestOptions
  ).then(handleResponse2);
}

function verifyDefaultToken(token) {
  const requestOptions = {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ token }),
  };
  return fetch(
    `${process.env.REACT_APP_BACKEND_API_URL}/api/v1/user/verify`,
    requestOptions
  ).then(handleVerifyToken);
}

function createPassword(defaultPasswordToken, oldPassword, newPassword) {
  const requestOptions = {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ defaultPasswordToken, oldPassword, newPassword }),
  };
  return fetch(
    `${process.env.REACT_APP_BACKEND_API_URL}/api/v1/user/password/create`,
    requestOptions
  ).then(handleResponse);
}

function verifyToken(resetPasswordToken) {
  const requestOptions = {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ resetPasswordToken }),
  };
  return fetch(
    `${process.env.REACT_APP_BACKEND_API_URL}/api/v1/user/password/token/verify`,
    requestOptions
  ).then(handleVerifyToken);
}

function changePassword(email, newPassword, clientId) {
  const requestOptions = {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ email, newPassword, clientId }),
  };
  return fetch(
    `${process.env.REACT_APP_BACKEND_API_URL}/api/v1/user/password`,
    requestOptions
  ).then(handleResponse);
}

function resetPassword(email, companyHostname) {
  const requestOptions = {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ email, companyHostname }),
  };
  return fetch(
    `${process.env.REACT_APP_BACKEND_API_URL}/api/v1/user/password/forgot`,
    requestOptions
  ).then(handleResponse);
}

function login(email, password, companyHostname) {
  const requestOptions = {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ email, password, companyHostname }),
  };

  return fetch(
    `${process.env.REACT_APP_BACKEND_API_URL}/api/v1/signin`,
    requestOptions
  )
    .then(handleResponse)
    .then((user) => {
      // store user details and jwt token in local storage to keep user logged in between page refreshes
      localStorage.setItem("user", JSON.stringify(user));
      return user;
    });
}

function logout() {
  // remove user from local storage to log user out
  localStorage.removeItem("user");
}

function getAllUsers(offset, limit) {
  let user = JSON.parse(localStorage.getItem("user"));
  const requestOptions = {
    method: "GET",
    headers: {
      "x-access-token": user.accessToken,
    },
  };

  return fetch(
    `${process.env.REACT_APP_BACKEND_API_URL}/api/v1/users/${offset}/${limit}`,
    requestOptions
  ).then(handleResponse);
}

function getAllUsersForImpersonation() {
  const offset = 0;
  const limit = null;
  let user = JSON.parse(localStorage.getItem("user"));
  const requestOptions = {
    method: "GET",
    headers: {
      "x-access-token": user.accessToken,
    },
  };

  return fetch(
    `${process.env.REACT_APP_BACKEND_API_URL}/api/v1/users/${offset}/${limit}`,
    requestOptions
  ).then(handleResponse);
}

function getUserTopCardInfo() {
  let user = JSON.parse(localStorage.getItem("user"));
  const requestOptions = {
    method: "GET",
    headers: {
      "x-access-token": user.accessToken,
    },
  };

  return fetch(
    `${process.env.REACT_APP_BACKEND_API_URL}/api/v1/users/cards`,
    requestOptions
  ).then(handleResponse2);
}

function editUserDetailsByAdmin(formData, userId) {
  let user = JSON.parse(localStorage.getItem("user"));
  const requestOptions = {
    method: "PUT",
    headers: {
      "x-access-token": user.accessToken,
      "Content-Type": "application/json",
    },
    body: JSON.stringify(formData),
  };

  return fetch(
    `${process.env.REACT_APP_BACKEND_API_URL}/api/v1/user/profile/${userId}`,
    requestOptions
  ).then(handleResponse2);
}

function getUserProfile() {
  let user = JSON.parse(localStorage.getItem("user"));
  const requestOptions = {
    method: "GET",
    headers: {
      "x-access-token": user.accessToken,
    },
  };

  return fetch(
    `${process.env.REACT_APP_BACKEND_API_URL}/api/v1/user/profile`,
    requestOptions
  ).then(handleResponse);
}

//Get All Cards for User
function getAllCardsForUser(userId, roleId) {
  let user = JSON.parse(localStorage.getItem("user"));
  const requestOptions = {
    method: "GET",
    headers: {
      "x-access-token": user.accessToken,
    },
  };
  return fetch(
    `${process.env.REACT_APP_BACKEND_API_URL}/api/v1/user/profile/cards/${roleId}/${userId}`,
    requestOptions
  ).then(handleResponse2);
}
function getById(id) {
  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };

  return fetch(
    `${process.env.REACT_APP_BACKEND_API_URL}/users/${id}`,
    requestOptions
  ).then(handleResponse);
}

function register(formData) {
  let userToken = JSON.parse(localStorage.getItem("user"));
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "x-access-token": userToken.accessToken,
    },
    body: JSON.stringify(formData),
  };

  return fetch(
    `${process.env.REACT_APP_BACKEND_API_URL}/api/v1/user`,
    requestOptions
  ).then(handleRegisterResponse);
}

function registerDemoClient(formData) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(formData),
  };
  return fetch(
    `${process.env.REACT_APP_BACKEND_API_URL}/api/v1/client/createUser`,
    requestOptions
  ).then(handleRegisterResponse);
}
function DuplicateUserNameForDemo(userName) {
  const requestOptions = {
    method: "GET",
  };
  return fetch(
    `${process.env.REACT_APP_BACKEND_API_URL}/api/v1/client/checkDuplicateUserName/${userName}`,
    requestOptions
  ).then(handleRegisterResponse);
}
function update(user) {
  const requestOptions = {
    method: "PUT",
    headers: { ...authHeader(), "Content-Type": "application/json" },
    body: JSON.stringify(user),
  };

  return fetch(
    `${process.env.REACT_APP_BACKEND_API_URL}/users/${user.id}`,
    requestOptions
  ).then(handleResponse);
}

// prefixed function name with underscore because delete is a reserved word in javascript
function _delete(id) {
  const requestOptions = {
    method: "DELETE",
    headers: authHeader(),
  };

  return fetch(
    `${process.env.REACT_APP_BACKEND_API_URL}/users/${id}`,
    requestOptions
  ).then(handleResponse);
}

function getAccessControl() {
  let user = JSON.parse(localStorage.getItem("user"));
  const requestOptions = {
    method: "GET",
    headers: {
      "x-access-token": user.accessToken,
    },
  };

  return fetch(
    `${process.env.REACT_APP_BACKEND_API_URL}/api/v1/authorization/policies`,
    requestOptions
  ).then(handleResponse2);
}

function getAccessControlForUser(userId) {
  let user = JSON.parse(localStorage.getItem("user"));
  const requestOptions = {
    method: "GET",
    headers: {
      "x-access-token": user.accessToken,
    },
  };

  return fetch(
    `${process.env.REACT_APP_BACKEND_API_URL}/api/v1/authorization/policies/${userId}`,
    requestOptions
  ).then(handleResponse2);
}

function postAccessControlForUser(formData, userId) {
  let user = JSON.parse(localStorage.getItem("user"));
  const requestOptions = {
    method: "POST",
    headers: {
      "x-access-token": user.accessToken,
      "Content-Type": "application/json",
    },
    body: JSON.stringify(formData),
  };

  return fetch(
    `${process.env.REACT_APP_BACKEND_API_URL}/api/v1/authorization/policies/${userId}`,
    requestOptions
  ).then(handleResponse2);
}

function getAccessControlForUserByToken() {
  let user = JSON.parse(localStorage.getItem("user"));
  const requestOptions = {
    method: "GET",
    headers: {
      "x-access-token": user.accessToken,
    },
  };

  return fetch(
    `${process.env.REACT_APP_BACKEND_API_URL}/api/v1/authorization/user/policies`,
    requestOptions
  ).then(handleResponse2);
}

function applyUserFilter(
  role,
  status,
  startDate,
  endDate,
  search,
  offset,
  limit
) {
  let user = JSON.parse(localStorage.getItem("user"));
  const sortBy = "DESC";
  const columnName = "createdAt";
  const requestOptions = {
    method: "POST",
    headers: {
      "x-access-token": user.accessToken,
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      role,
      status,
      startDate,
      endDate,
      search,
      offset,
      limit,
    }),
  };

  return fetch(
    `${process.env.REACT_APP_BACKEND_API_URL}/api/v1/users/filter/${limit}/${offset}/${sortBy}/${columnName}`,
    requestOptions
  ).then(handleResponse2);
}

function getSessionInfo(sessionId) {
  const requestOptions = {
    method: "GET",
  };

  return fetch(
    `${process.env.REACT_APP_BACKEND_API_URL}/api/v1/checkoutSession?sessionId=${sessionId}`,
    requestOptions
  ).then(handleResponse2);
}

function onboardRequest(formData) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(formData),
  };

  return fetch(
    `${process.env.REACT_APP_BACKEND_API_URL}/api/v1/company`,
    requestOptions
  ).then(handleResponse2);
}
//retrieveCustomerDetails
function retrieveCustomerDetails(customerId) {
  const requestOptions = {
    method: "GET",
    headers: {
      "Content-type": "application/json",
    },
  };
  return fetch(
    `${process.env.REACT_APP_BACKEND_API_URL}/api/v1/subscription/customer/${customerId}`,
    requestOptions
  ).then(handleResponse2);
}
//applyFilterNofitications
function applyFilterNofitications(
  status,
  user,
  type,
  startDate,
  endDate,
  search,
  limit,
  offset
) {
  let users = JSON.parse(localStorage.getItem("user"));
  const sortBy = "DESC";
  const columnName = "createdAt";
  const requestOptions = {
    method: "POST",
    headers: {
      "content-type": "application/json",
      "x-access-token": users.accessToken,
    },
    body: JSON.stringify({
      status,
      user,
      type,
      startDate,
      endDate,
      search,
    }),
  };
  return fetch(
    `${process.env.REACT_APP_BACKEND_API_URL}/api/v1/notification/filter/${limit}/${offset}/${sortBy}/${columnName}`,
    requestOptions
  ).then(handleResponse2);
}
function checkDuplicateUserName(userName) {
  let user = JSON.parse(localStorage.getItem("user"));
  const requestOptions = {
    method: "GET",
    headers: {
      "x-access-token": user.accessToken,
    },
  };

  return fetch(
    `${process.env.REACT_APP_BACKEND_API_URL}/api/v1/users/username/check/${userName}`,
    requestOptions
  ).then(handleResponse2);
}

function fetchAllLoginDetailsForUser(userId) {
  let user = JSON.parse(localStorage.getItem("user"));
  const requestOptions = {
    method: "GET",
    headers: {
      "x-access-token": user.accessToken,
    },
  };
  return fetch(
    `${process.env.REACT_APP_BACKEND_API_URL}/api/v1/session/user/${userId}`,
    requestOptions
  ).then(handleResponse2);
}

function fetchAllLoginDetails(offset = 0, limit = 10) {
  let user = JSON.parse(localStorage.getItem("user"));
  const requestOptions = {
    method: "GET",
    headers: {
      "x-access-token": user.accessToken,
    },
  };
  return fetch(
    `${process.env.REACT_APP_BACKEND_API_URL}/api/v1/session/${offset}/${limit}`,
    requestOptions
  ).then(handleResponse2);
}

function userSessionTopCards() {
  let user = JSON.parse(localStorage.getItem("user"));
  const requestOptions = {
    method: "GET",
    headers: {
      "x-access-token": user.accessToken,
    },
  };
  return fetch(
    `${process.env.REACT_APP_BACKEND_API_URL}/api/v1/session/cards`,
    requestOptions
  ).then(handleResponse2);
}

function getAllUserSessionFilters() {
  let user = JSON.parse(localStorage.getItem("user"));
  const requestOptions = {
    method: "GET",
    headers: {
      "x-access-token": user.accessToken,
    },
  };
  return fetch(
    `${process.env.REACT_APP_BACKEND_API_URL}/api/v1/session/filter/props`,
    requestOptions
  ).then(handleResponse2);
}

function applyUserSessionFilters(formData, offset, limit) {
  const sortBy = "ASC";
  const columnName = "isDeleted";
  let user = JSON.parse(localStorage.getItem("user"));

  const requestOptions = {
    method: "POST",
    headers: {
      "x-access-token": user.accessToken,
      "content-type": "application/json",
    },
    body: JSON.stringify(formData),
  };
  return fetch(
    `${process.env.REACT_APP_BACKEND_API_URL}/api/v1/session/filter/${limit}/${offset}/${sortBy}/${columnName}`,
    requestOptions
  ).then(handleResponse2);
}

function logutUserByTokenId(tokenIds) {
  let user = JSON.parse(localStorage.getItem("user"));
  const requestOptions = {
    method: "PUT",
    headers: {
      "x-access-token": user.accessToken,
      "content-type": "application/json",
    },
    body: JSON.stringify(tokenIds),
  };
  return fetch(
    `${process.env.REACT_APP_BACKEND_API_URL}/api/v1/session/logout`,
    requestOptions
  ).then(handleResponse2);
}

// function closeAccount(formData) {
//   let user = JSON.parse(localStorage.getItem("user"));
//   const requestOptions = {
//     method: "POST",
//     headers: {
//       "x-access-token": user.accessToken,
//       "content-type": "application/json",
//     },
//     body: JSON.stringify(formData)
//   }
//   return fetch(`${process.env.REACT_APP_BACKEND_API_URL}/api/v1/account/close`, requestOptions).then(handleResponse2)
// }

function verfiyUserSubscription(token) {
  const requestOptions = {
    method: "POST",
    headers: {
      "content-type": "application/json",
    },
    body: JSON.stringify({ token }),
  };
  return fetch(
    `${process.env.REACT_APP_BACKEND_API_URL}/api/v1/subscription/verify`,
    requestOptions
  ).then(handleResponse2);
}

function resendUserVerification(email, companyHostname) {
  const requestOptions = {
    method: "POST",
    headers: {
      "content-type": "application/json",
    },
    body: JSON.stringify({ email, companyHostname }),
  };
  return fetch(
    `${process.env.REACT_APP_BACKEND_API_URL}/api/v1/user/token/resend`,
    requestOptions
  ).then(handleResponse2);
}

//user impersona
function loginAsUserImpersona(userId) {
  let user = JSON.parse(localStorage.getItem("user"));
  const requestOptions = {
    method: "POST",
    headers: {
      "x-access-token": user.accessToken,
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ userId }),
  };
  return fetch(
    `${process.env.REACT_APP_BACKEND_API_URL}/api/v1/user/impersonate`,
    requestOptions
  )
    .then(handleResponse)
    .then((impersonaUser) => {
      localStorage.setItem("user", JSON.stringify(impersonaUser));
      return impersonaUser;
    });
}
function createMPin(mpin, userId) {
  let user = JSON.parse(localStorage.getItem("user"));
  const requestOptions = {
    method: "PUT",
    headers: {
      "x-access-token": user.accessToken,
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ mpin }),
  };
  return fetch(
    `${process.env.REACT_APP_BACKEND_API_URL}/api/v1//api/v1/user/mpin/create/${userId}`,
    requestOptions
  ).then(handleResponse);
}

function managedAInotification(aiNotification) {
  let user = JSON.parse(localStorage.getItem("user"));
  const requestOptions = {
    method: "PUT",
    headers: {
      "x-access-token": user.accessToken,
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ aiNotification }),
  };
  return fetch(
    `${process.env.REACT_APP_BACKEND_API_URL}/api/v1/user/notification`,
    requestOptions
  ).then(handleResponse);
}

function updateIsNewNotificationId(notificationId = null) {
  let user = JSON.parse(localStorage.getItem("user"));
  const requestOptions = {
    method: "PUT",
    headers: {
      "x-access-token": user.accessToken,
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ notificationId }),
  };
  return fetch(
    `${process.env.REACT_APP_BACKEND_API_URL}/api/v1/notification/count`,
    requestOptions
  ).then(handleResponse);
}

function getAllActiveUsers() {
  let user = JSON.parse(localStorage.getItem("user"));
  const requestOptions = {
    method: "GET",
    headers: {
      "x-access-token": user.accessToken,
    },
  };
  return fetch(
    `${process.env.REACT_APP_BACKEND_API_URL}/api/v1/users/active`,
    requestOptions
  ).then(handleResponse);
}

function getNotification() {
  let user = JSON.parse(localStorage.getItem("user"));
  const requestOptions = {
    method: "GET",
    headers: {
      "x-access-token": user.accessToken,
    },
  };
  return fetch(
    `${process.env.REACT_APP_BACKEND_API_URL}/api/v1/notifications`,
    requestOptions
  ).then(handleResponse);
}

function searchNotification(searchText, offset, limit) {
  let user = JSON.parse(localStorage.getItem("user"));
  const requestOptions = {
    method: "GET",
    headers: {
      "x-access-token": user.accessToken,
    },
  };
  return fetch(
    `${process.env.REACT_APP_BACKEND_API_URL}/api/v1/notification/search/${searchText}/${offset}/${limit}`,
    requestOptions
  ).then(handleResponse);
}

function applyNotification(
  createdBy,
  status,
  startDate,
  endDate,
  search,
  offset,
  limit
) {
  let users = JSON.parse(localStorage.getItem("user"));
  const requestOptions = {
    method: "POST",
    headers: {
      "content-type": "application/json",
      "x-access-token": users.accessToken,
    },
    body: JSON.stringify({
      startDate,
      endDate,
      search,
      status,
      createdBy,
    }),
  };
  return fetch(
    `${process.env.REACT_APP_BACKEND_API_URL}/api/v1/notification/filter/${limit}/${offset}`,
    requestOptions
  ).then(handleResponse2);
}

function handleResponse2(response) {
  return response.text().then((text) => {
    const data = text && JSON.parse(text);

    if (!response.ok) {
      if (response.status === 500) {
        // // location.reload(true);
      }
      // checking token expiry
      if (
        response.status === 401 &&
        data.message.includes("Invalid JWT token")
      ) {
        //redirecting to signin page
        history.push("/auth/signin");
        //removing local storage token
        localStorage.removeItem("user");
        return;
      }
      const error = (data && data.message) || response.statusText;
      return Promise.reject(error);
    }

    return data;
  });
}

function fetchNotificationOptions() {
  let user = JSON.parse(localStorage.getItem("user"));
  const requestOptions = {
    method: "GET",
    headers: {
      "x-access-token": user.accessToken,
    },
  };
  return fetch(
    `${process.env.REACT_APP_BACKEND_API_URL}/api/v1/notification/options`,
    requestOptions
  ).then(handleResponse);
}

function signup(payload) {
  // let user = JSON.parse(localStorage.getItem("user"));
  const requestOptions = {
    method: "POST",
    headers: {
      // "x-access-token": user.accessToken,
      "Content-Type": "application/json",
    },
    body: JSON.stringify(payload),
  };
  return fetch(
    `${process.env.REACT_APP_BACKEND_API_URL}/api/v1/signup`,
    requestOptions
  ).then(handleResponse);
}

function checkDomainAvailability(data) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  };
  return fetch(
    `${process.env.REACT_APP_BACKEND_API_URL}/api/v1/signup/domain/check`,
    requestOptions
  ).then(handleResponse);
}

function generateEmailOTP(email, companyId, userId) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ email, companyId, userId }),
  };
  return fetch(
    `${process.env.REACT_APP_BACKEND_API_URL}/api/v1/signup/generateOtp`,
    requestOptions
  ).then(handleResponse);
}

function verifyEmailOTP(email, otp) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ email, otp }),
  };
  return fetch(
    `${process.env.REACT_APP_BACKEND_API_URL}/api/v1/signup/verifyOtp`,
    requestOptions
  ).then(handleResponse);
}

function resendEmailOTP(email, companyId, userId) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ email, companyId, userId }),
  };
  return fetch(
    `${process.env.REACT_APP_BACKEND_API_URL}/api/v1/signup/resendOtp`,
    requestOptions
  ).then(handleResponse);
}

function handleResponse(response) {
  return response.text().then((text) => {
    const data = text && JSON.parse(text);

    if (!response.ok) {
      if (response.status === 500) {
        // auto logout if 401 response returned from api
        // logout();
        // location.reload(true);
      }
      // checking token expiry
      if (
        response.status === 401 &&
        data.message.includes("Invalid JWT token")
      ) {
        //redirecting to signin page
        history.push("/auth/signin");
        //removing local storage token
        localStorage.removeItem("user");
        return;
      }

      const error = (data && data.message) || response.statusText;
      return Promise.reject(error);
    }

    return data;
  });
}

function handleRegisterResponse(response) {
  return response.text().then((text) => {
    const data = text && JSON.parse(text);

    if (!response.ok) {
      if (response.status === 500) {
      }

      const error = (data && data.message) || response.statusText;
      return Promise.reject(error);
    }
    return data;
  });
}

function handleVerifyToken(response) {
  return response.text().then((text) => {
    const data = text && JSON.parse(text);

    if (!response.ok) {
      if (response.status === 500) {
        // auto logout if 401 response returned from api
        // logout();
        // location.reload(true);
      }

      const error = (data && data.message) || response.statusText;
      return Promise.reject(error);
    }

    return data;
  });
}
